import React, {Component} from 'react';
import ReactDOM from "react-dom";
import EmailMeForm from '../email-me-stock/EmailMeForm';

export class ProductEmailMe extends Component {
  static init (containerClass) {
    const container = document.querySelector(containerClass);
    if(container) {
      const { skuId, productId, type, notifyNewlyInStock } = container.dataset;

      ReactDOM.render(
        <EmailMeForm
          productId={productId}
          skuId={skuId}
          type={type}
          notifyNewlyInStock={notifyNewlyInStock}
        />,
        container
      );
    }
  }

}
